import { Line, Bar, Doughnut, Scatter } from 'vue-chartjs'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('LineChart', Line)
  nuxtApp.vueApp.component('BarChart', Bar)
  nuxtApp.vueApp.component('DoughnutChart', Doughnut)
  nuxtApp.vueApp.component('ScatterChart', Scatter)
})
